import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  NgZone,
  ViewChild,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { UiDropdownComponent } from '@ui';
import { routerSegments } from '../../consts/routes';
import { AuthActions } from '../../store/state/auth/auth.actions';
import { userFeature } from '../../store/state/user/user.feature';

@Component({
  selector: 'app-user-menu',
  imports: [MatTooltip, TranslatePipe, UiDropdownComponent],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent implements AfterViewInit {
  private readonly store = inject(Store);
  private readonly ngZone = inject(NgZone);
  private readonly router = inject(Router);

  @ViewChild('userMenu')
  public userMenu?: ElementRef<HTMLElement>;

  protected readonly profile = this.store.selectSignal(
    userFeature.selectProfile,
  );
  protected userMenuHeight = 0;

  public ngAfterViewInit(): void {
    this.ngZone.onStable.pipe(take(1)).subscribe(() => {
      this.userMenuHeight = this.userMenu?.nativeElement.clientHeight ?? 0;
    });
  }

  protected openAccountDetails(): void {
    void this.router.navigate(['/', routerSegments.accountDetails]);
  }

  protected logout(): void {
    this.store.dispatch(AuthActions.logout({ msg: null }));
  }
}
